import React, { useEffect, useState, useMemo } from "react";

import { Col, Row } from "reactstrap";
import DataTable from "../../shared/base-components/DataTable";
import { Personel } from "./TodayTask.constants";

const TodayTaskList = () => {
  document.title =
    "Alınacak Ücretler | Bu ekranda alınacak ücretli listesini görebilirsiniz.";

  // const { data, mutate, isLoading } = useTodayTaskListMutation()
  const dummyData: any = [
    {
      fullname: "Ferhat Dummy",
      phone: "05074458942",
      price: "Ezrağı bitirceksin",
    },
    {
      fullname: "Ferhat Dummy",
      phone: "05074458942",
      price: "Ezrağı bitirceksin",
    },
    {
      fullname: "Ferhat Dummy",
      phone: "05074458942",
      price: "Ezrağı bitirceksin",
    },
    {
      fullname: "Ferhat Dummy",
      phone: "05074458942",
      price: "Ezrağı bitirceksin",
    },
  ];

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [modalOptions, setModalOptions] = useState<{
    data?: Personel;
    modalType?: string;
  }>({
    data: undefined,
    modalType: undefined,
  });

  const toggle = () => {
    setIsModalOpen(!isModalOpen);
  };

  const modalOptionsHandler = (data?: Personel, modalType?: string) => {
    setModalOptions({ data: data, modalType: modalType });
  };

  const columns = useMemo(
    () => [
      {
        Header: "Görev",
        accessor: "price",
        filterable: false,
        disableFilters: true,
        Cell: (response: any) => (
          <>{<p className="text mb-0">{response.row.original?.price}</p>}</>
        ),
      },
      {
        Header: "Atanan Kişi",
        filterable: false,
        disableFilters: true,
        accessor: "fullname",
        Cell: (response: any) => (
          <>
            <p className="text mb-0">{response.row.original.fullname}</p>
          </>
        ),
      },
      {
        Header: "Telefon",
        accessor: "phone",
        filterable: false,
        disableFilters: true,
        Cell: (response: any) => {
          return <p className="text mb-0">{response.row.original?.phone}</p>;
        },
      },
    ],
    []
  );

  useEffect(() => {
    // !isModalOpen && mutate({})
  }, [isModalOpen]);

  return (
    <React.Fragment>
      <Row className="align-items-center">
        <Col md={6}>
          <div className="mb-3">
            <h5 className="card-title">
              Alınacak Ücretler Listesi
              <span className="text-muted fw-normal ms-2">
                ({dummyData?.length})
              </span>
            </h5>
          </div>
        </Col>

        <Col md={6}>
          <div className="d-flex flex-wrap align-items-center justify-content-end gap-2 mb-3">
            <div>
              <ul className="nav nav-pills"></ul>
            </div>
            <div></div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col lg="12">
          {dummyData?.length && (
            <DataTable
              columns={columns}
              data={dummyData}
              isGlobalFilter={true}
              isAddUserList={true}
              customPageSize={10}
              className="table align-middle datatable dt-responsive table-check nowrap"
            />
          )}
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default TodayTaskList;
